import { Grid, Typography } from "@mui/material";
import { VFC } from "react";
import { useTranslation } from "react-i18next";
import { getGroupTypeTranslationForLabel } from "../../../utils/group.helper";
import { GroupType } from "../../../domain/group/group-type";

interface IGroupDetailTypeNameProps {
  type: GroupType;
}

export const GroupDetailTypeInfoName: VFC<IGroupDetailTypeNameProps> = (props) => {
  const { type } = props;
  const { t } = useTranslation();

  return (
    <Grid container direction="row" justifyContent="space-between">
      <Grid item xs={10} md="auto">
        <Typography variant="h1">{getGroupTypeTranslationForLabel(type, t)}</Typography>
      </Grid>
    </Grid>
  );
};
